import React, { useState, useEffect, useContext } from 'react'
import { components, DisabledContext, NamePrefixContext, ErrorPathContext, SchemaContext, evaluateFunctionDefault, defaults } from '../detailsPageComponents'

export default function NavButtonsList({
  name,
  disabled,
  ItemRenderer,
  newItem,
  canDelete,
  titleFunction,
  onChange,
  getErrorClass,
  className,
  fields,
  value,
  containerClassName,
  navButtonProps,
  emptyListPlaceholder,
  newButtonProps,
  closeButtonProps,
  closeButtonText = defaults.closeButtonText
}) {
  const schema = useContext(SchemaContext)
  const { Button, ErrorIcon } = components
  const [isOpen, setIsOpen] = useState()
  useEffect(() => {
    if (value.length && !isOpen) setIsOpen(`${name}.0`)
    else if (!value.length && isOpen) setIsOpen()
  }, [value])

  function handleAddNewItem() {
    newItem({ path: name })
    setIsOpen(`${name}.${value.length}`)
  }

  function handleRemoveItem(e, i) {
    e.stopPropagation()
    e.preventDefault()
    const isOpenIdx = isOpen.split('.').at(-1)
    if (Number(isOpenIdx) >= Number(i)) setIsOpen(`${name}.${isOpenIdx - 1}`)
    const newData = value.toSpliced(i, 1)
    onChange({ [name]: newData })
  }
  const ErrorComponent = ({ path }) => {
    if (!schema?.hasChildError(path)) return null
    return <ErrorIcon className={getErrorClass(schema.getChildErrors(path)?.flat()) + ' list-button__error'}/>
  }

  return (
    <div className={`schema-form__list ${containerClassName || ''}`}>
      <div className="schema-form__list-tiles">
        {value.map((item, i) => {
          const key = `${name}.${i}`
          return (
            <div key={key} className='schema-form__list-tile'>
              <Button
                {...evaluateFunctionDefault(navButtonProps, { selected: key === isOpen, disabled })}
                onClick={() => setIsOpen(key)}
              >
                {typeof titleFunction === 'function' ? (titleFunction.length > 1 ? titleFunction(item, () => ErrorComponent({ path: key })) : <>{titleFunction(item)}<ErrorComponent path={key}/></>) : <span>{i}<ErrorComponent path={key}/></span>}
              </Button>
              {evaluateFunctionDefault(canDelete, { item, index: i })
                ? <Button {...evaluateFunctionDefault(closeButtonProps, { disabled })} onClick={(e) => handleRemoveItem(e, i)}>{closeButtonText}</Button>
                : null
              }
            </div>
          )
        })}
        {value?.length ? null : <span className="schema-form__list-preview-empty__text">{emptyListPlaceholder}</span>}
        {!disabled && newItem
        && <div className="schema-form__list-tile-add-button">
          <Button
            {...evaluateFunctionDefault(newButtonProps, { disabled })}
            onClick={handleAddNewItem}
          />
        </div>
        }
      </div>
      <div className="schema-form__list-preview">
        {
          isOpen
            ? (
              <NamePrefixContext.Provider value={isOpen}>
                <ErrorPathContext.Provider value={isOpen}>
                  <DisabledContext.Provider value={disabled}>
                    <ItemRenderer fields={fields} className={className} value={value} />
                  </DisabledContext.Provider>
                </ErrorPathContext.Provider>
              </NamePrefixContext.Provider>
            )
            : null
        }
      </div>
    </div>
  )
}

NavButtonsList.componentKey = 'navButtonsList'
